import React, {
  HTMLAttributes,
  ImgHTMLAttributes,
  MouseEvent,
  useState,
} from 'react';
import PreviewPlayButton from '#/components/Form/PreviewPlayButton/PreviewPlayButton';
import { spotifyApiConfig } from '#/utils/constants';
import ApiManager from '#/services/api/ApiManager';
import useDeviceId from '#/hooks/useDeviceId';
import useProtectedSpotify from '#/hooks/useProtectedAxios';

interface IProperties {
  image?: ImgHTMLAttributes<HTMLImageElement>['src'];
  name?: string;
  description?: string;
  loading?: boolean;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
  uri?: string;
}

const PlaylistPreview = (properties: IProperties) => {
  const [hover, setHover] = useState(false);

  const { image, name, description, loading, onClick, uri } = properties;

  const handleMouseEnter = () => setHover(true);

  const handleMouseLeave = () => setHover(false);

  const { retrieveDeviceId } = useDeviceId();

  const protectedSpotify = useProtectedSpotify();

  const handleClickPlay = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    const apiManager = new ApiManager(spotifyApiConfig, protectedSpotify);

    const response = await apiManager.replaceEntity(
      'playerPlay',
      '',
      {
        context_uri: uri,
      },
      {
        device_id: retrieveDeviceId(),
      }
    );
    if ('error' in response) {
      // TODO: handle error
      // eslint-disable-next-line no-console
      console.log('Cant reproduce');
    }
  };

  return (
    <div
      className="h-full w-full aspect-[210/290] p-4 transition-colors duration-300 bg-theme-dark-gray rounded-md shadow-theme-darker-gray shadow-lg hover:cursor-pointer hover:bg-theme-gray"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {loading ? (
        <>
          <div
            className={`w-full aspect-square rounded-md mb-4 shadow-theme-darker-gray shadow-lg animate-pulse bg-theme-gray`}
          />
          <div className=" w-5/6 rounded-full h-6 mb-1 animate-pulse bg-theme-gray" />
          <div className=" w-2/3 rounded-full h-5 animate-pulse bg-theme-gray" />
        </>
      ) : (
        <>
          <div className=" relative aspect-square mb-4 rounded-md overflow-hidden">
            <img
              className="w-full h-full object-cover shadow-theme-darker-gray shadow-lg"
              src={image}
              alt={`Image of ${name} playlist`}
              loading="lazy"
            />
            <PreviewPlayButton hover={hover} onClick={handleClickPlay} />
          </div>
          <span className=" block text-theme-white font-bold mb-1 one-line-text">
            {name}
          </span>
          <p className="text-sm text-theme-light-gray line-clamp-2">
            {description}
          </p>
        </>
      )}
    </div>
  );
};

export default PlaylistPreview;
